import { Multiselect, Select } from '@amzn/awsui-components-react-v3';
import React from 'react';
import { padZero } from '../../utils/date-utils';
import { Asterisk } from './asterisk';
import { SelectedTokenLimits } from '../const/dropdown_elements'
import {findOption, findOptions} from "../reports/utils/buttons";
import { TWO_ZERO_WIDTH_SPACE, ZERO_WIDTH_SPACE } from '../../styles/common_styles';

export class TimeFrameButton extends React.Component {

  getDropdownOptions = (yearQuarter = true, reverse = false, exclude = null) => {
      let options = [];
      let currentDate = new Date(this.props.startMonth/100, this.props.startMonth%100 - 1);
      let endDate = new Date(this.props.endMonth/100, this.props.endMonth%100 - 1);
      while(currentDate.getTime() <= endDate.getTime()){
          let year = currentDate.getFullYear();
          let month = currentDate.getMonth() + 1;
          options.unshift({
              'label': TWO_ZERO_WIDTH_SPACE + currentDate.toLocaleString('default', {month: 'short'}) + ' ' + year,
              'value': `${year}/${padZero(month)}`,
          });
          if((month % 3 === 0 || currentDate.getTime() === endDate.getTime()) && yearQuarter){
              options.unshift({
                  'label': ZERO_WIDTH_SPACE + `Q${Math.ceil(month/3)} ${year}`,
                  'value': `${year}Q${Math.ceil(month/3)}`
              })
          }
          if((month === 12 || currentDate.getTime() === endDate.getTime()) && yearQuarter){
              options.unshift({
                  'label': `${year}`,
                  'value': `${year}`,
              });
          }
          currentDate.setMonth(month);
      }
    options = exclude ? options.filter(opt => !exclude.some(e => e === opt.value)) : options;
    return reverse? options.reverse() : options;
  };

  render() {
    if(this.props.multiSelect){
        let options = this.getDropdownOptions(this.props.hasOwnProperty('yearQuarter') ? this.props.yearQuarter: true,
            this.props.hasOwnProperty('reverse') ? this.props.reverse : false,
            this.props.exclude);
        return (
            <div>
                <b> {this.props.text} </b>
                <Asterisk required={this.props.required}/>
                <Multiselect
                className={'TreeMultiSelect'}
                options={options}
                placeholder={this.props.hasOwnProperty('placeholder')? this.props.placeholder : this.props.text}
                onChange={this.props.onChange}
                selectedOptions={findOptions(options, this.props.selected)}
                tokenLimit={this.props.tokenLimit || SelectedTokenLimits.TIME_FRAME || SelectedTokenLimits.DEFAULT}
                data-cy={this.props['data-cy']}
                disabled={this.props.disabled}
                />
            </div>
        );
    }else{
        let options = this.getDropdownOptions(this.props.multiSelect, this.props.reverse? this.props.reverse : false);
        return (
          <div>
              <b> {this.props.text} </b>
              <Asterisk required={this.props.required}/>
              <Select
                options={options}
                placeholder={this.props.hasOwnProperty('placeholder')? this.props.placeholder : this.props.text}
                onChange={this.props.onChange}
                selectedOption={findOption(options, this.props.selected)}
                data-cy={this.props['data-cy']}
              />
          </div>
        )
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/buttons/time_frame_button.jsx